import React, { useState } from 'react';
import './ProactiveRX.css';

const ProactiveRX = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="ProactiveRX-container">
            <h1 className="ProactiveRX-title">Proactive RX</h1>

            {/* Link Box */}
            <a href="https://ca.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=eb6c2720-e3db-4f30-b159-03b5a9b0f414&env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&v=2" target="_blank" rel="noopener noreferrer" className="ProactiveRX-box">
                <div className="ProactiveRX-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="ProactiveRX-faq-section">
                <h2 className="ProactiveRX-faq-title">Frequently Asked Questions</h2>
                <div className="ProactiveRX-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`ProactiveRX-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="ProactiveRX-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="ProactiveRX-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`ProactiveRX-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProactiveRX;